module.exports = __webpack_public_path__ + "img/product.9a5e2fb2.png";